import React from 'react';
import { NoticeDataType } from '.';
import { ENUM_NOTICE_STATUS } from 'utils/enum';

const NoticeCardHeader = ({ data }: { data: NoticeDataType }) => {
  const { title, status } = data;
  return (
    <div className='flex justify-between items-center border-b-[0.7px] border-[#EAEBEB] py-2'>
      <p className='pl-[18px] text-[#1A1A1A] font-medium  '>{title}</p>
      <span
        style={{
          backgroundColor:
            status === ENUM_NOTICE_STATUS.ACTIVE
              ? '#E5F9E2'
              : status === ENUM_NOTICE_STATUS.INACTIVE
              ? '#F0F0F0'
              : 'E1F3FF',
          color:
            status === ENUM_NOTICE_STATUS.ACTIVE
              ? '#3FB827'
              : status === ENUM_NOTICE_STATUS.INACTIVE
              ? '#808080'
              : '#0EA3FD'
        }}
        className={`rounded-[40px] text-xs leading-[19px] px-4 py-1 mr-[18px]`}>
        <p className='capitalize'> {status} </p>
      </span>
    </div>
  );
};

export default NoticeCardHeader;
